import { EventBasicInformation } from '../../../../contexts/EventContext/types';

export const getCheckAvailabilityWidgetEventId = ({
    waitlistToken,
    basicEventInformation,
}: {
    waitlistToken?: string;
    basicEventInformation: EventBasicInformation;
}) => {
    // If we have a waitlist token, we should use the child event ID
    if (waitlistToken && basicEventInformation.id) {
        return basicEventInformation.id;
    }
    // Otherwise use parent ID for normal timed entry flow
    return basicEventInformation.parentEventId;
};
